// Sign-up/login screen, OAuth callback, verify-account page.
export const auth: Record<string, string> = {
  // ── Sign-up / login screen ──
  'Welcome back!': 'Dobro došao nazad!',
  'Passwords do not match': 'Lozinke se ne poklapaju',
  'Username already taken': 'Korisničko ime je već zauzeto',
  'Check your email to confirm your account!': 'Proveri imejl da potvrdiš svoj nalog!',
  'Account created! Welcome to ShowMeTrade.': 'Nalog je napravljen! Dobro došao na ShowMeTrade.',
  'Google sign-in failed. Please try again.': 'Prijava preko Google-a nije uspela. Pokušaj ponovo.',
  'Trade ideas from': 'Trejd ideje od',
  'real traders': 'pravih trejdera',
  ', in real time.': ', u realnom vremenu.',
  'Follow top performers, share your setups, and build a track record that speaks for itself.':
    'Prati najbolje trejdere, deli svoje setape i gradi istoriju rezultata koja govori sama za sebe.',
  'On every idea': 'Uz svaku ideju',
  'Risk-adjusted': 'Prilagođeno riziku',
  'Win/loss by price': 'Dobitak/gubitak po ceni',
  'Auto-tracked': 'Automatski praćeno',
  'Live feed preview': 'Pregled feeda uživo',
  '23m ago': 'pre 23 min',
  '2h ago': 'pre 2 h',
  '5h ago': 'pre 5 h',
  '7h ago': 'pre 7 h',
  'Community-driven': 'Pokreće zajednica',
  'Verified track records': 'Verifikovani rezultati',
  'Real-time ideas': 'Ideje u realnom vremenu',
  'You were invited by': 'Pozvao te je',
  "You've been invited!": 'Dobio si pozivnicu!',
  'Create your account and post your first idea to claim a': 'Napravi nalog i objavi svoju prvu ideju da osvojiš',
  '+100 XP welcome bonus': 'bonus dobrodošlice od +100 XP',
  'Create Account': 'Napravi nalog',
  'Sign in with Google': 'Prijavi se preko Google-a',
  'Sign up with Google': 'Registruj se preko Google-a',
  'OR CONTINUE WITH EMAIL': 'ILI NASTAVI PUTEM IMEJLA',
  'EMAIL ADDRESS': 'E-ADRESA',
  'Email is required': 'E-adresa je obavezna',
  'Enter a valid email address': 'Unesi ispravnu e-adresu',
  'PASSWORD': 'LOZINKA',
  'Forgot password?': 'Zaboravljena lozinka?',
  'Password is required': 'Lozinka je obavezna',
  'Password must be at least 8 characters': 'Lozinka mora imati najmanje 8 karaktera',
  'Remember me': 'Zapamti me',
  'Signing in…': 'Prijavljivanje…',
  'Sign In to ShowMeTrade': 'Prijavi se na ShowMeTrade',
  "Don't have an account?": 'Nemaš nalog?',
  'Create account': 'Napravi nalog',
  'USERNAME': 'KORISNIČKO IME',
  'This is your public handle — other traders will see this on your ideas.':
    'Ovo je tvoje javno korisničko ime — drugi trejderi će ga videti uz tvoje ideje.',
  'Username is required': 'Korisničko ime je obavezno',
  'At least 3 characters': 'Najmanje 3 karaktera',
  'Max 20 characters': 'Najviše 20 karaktera',
  'Lowercase letters, numbers, and underscores only': 'Samo mala slova, brojevi i donja crta',
  'your_handle': 'tvoje_ime',
  'Minimum 8 characters. Use a mix of letters, numbers, and symbols.':
    'Najmanje 8 karaktera. Kombinuj slova, brojeve i simbole.',
  'At least 8 characters': 'Najmanje 8 karaktera',
  'Must include uppercase, lowercase, and a number': 'Mora sadržati veliko slovo, malo slovo i broj',
  'CONFIRM PASSWORD': 'POTVRDI LOZINKU',
  'Please confirm your password': 'Potvrdi svoju lozinku',
  'Creating account…': 'Pravljenje naloga…',
  'Create My Account': 'Napravi moj nalog',
  'By creating an account you agree to our': 'Pravljenjem naloga prihvataš naše',
  'Terms of Service': 'Uslove korišćenja',
  'Privacy Policy': 'Politiku privatnosti',
  'Already have an account?': 'Već imaš nalog?',
  'Back to homepage': 'Nazad na početnu',
  'Sign in': 'Prijavi se',
  'Back to sign in': 'Nazad na prijavu',
  'Check your email': 'Proveri svoj imejl',
  'We sent a password reset link to your email address. Click the link to reset your password.':
    'Poslali smo link za resetovanje lozinke na tvoju e-adresu. Klikni na link da resetuješ lozinku.',
  'Back to Sign In': 'Nazad na prijavu',
  'Reset your password': 'Resetuj lozinku',
  "Enter your email address and we'll send you a link to reset your password.":
    'Unesi svoju e-adresu i poslaćemo ti link za resetovanje lozinke.',
  'Sending…': 'Slanje…',
  'Send Reset Link': 'Pošalji link za resetovanje',

  // ── OAuth callback ──
  'Signing you in…': 'Prijavljujemo te…',

  // ── Verify account ──
  'Back to feed': 'Nazad na feed',
  'Get Live-Verified': 'Postani Live-Verified',
  'Connect your own real exchange account (read-only) to earn a Live-Verified track record from real fills. Free.':
    'Poveži svoj pravi nalog na berzi (samo za čitanje) i zaradi Live-Verified istoriju rezultata iz stvarnih izvršenja. Besplatno.',
  'Connected accounts': 'Povezani nalozi',
  'verified fills': 'verifikovanih izvršenja',
  'synced': 'sinhronizovano',
  'Create a Binance API key with': 'Napravi Binance API ključ sa',
  'only "Enable Reading"': 'samo "Enable Reading" dozvolom',
  '— no spot/margin/futures trading, no withdrawals. We validate this and reject any key with trade or withdrawal access. Your key+secret are encrypted server-side (never shown in the browser) and used read-only.':
    '— bez spot/margin/futures trgovanja, bez isplata. To proveravamo i odbijamo svaki ključ sa pristupom trgovanju ili isplatama. Tvoj ključ i tajni ključ su šifrovani na serveru (nikad se ne prikazuju u pregledaču) i koriste se samo za čitanje.',
  'Connect Binance (read-only)': 'Poveži Binance (samo za čitanje)',
  'API KEY': 'API KLJUČ',
  'Binance API key': 'Binance API ključ',
  'API SECRET': 'API TAJNI KLJUČ',
  'Binance API secret': 'Binance API tajni ključ',
  'Connected — imported': 'Povezano — uvezeno',
  'fills': 'izvršenja',
  'across': 'na',
  'symbol(s)': 'simbol(a)',
  'Coverage:': 'Pokrivenost:',
  'Validating & importing…': 'Provera i uvoz…',
  'Connect read-only key': 'Poveži ključ (samo za čitanje)',
  'Import Myfxbook (forex)': 'Uvezi Myfxbook (forex)',
  'Make your Myfxbook account': 'Podesi svoj Myfxbook nalog kao',
  'public': 'javan',
  ', then paste its account id or public URL. No password needed — we read your verified history and apply our gates. Existing history can qualify you instantly.':
    ', zatim nalepi njegov ID ili javni URL. Lozinka nije potrebna — čitamo tvoju verifikovanu istoriju i primenjujemo naše kriterijume. Postojeća istorija može odmah da te kvalifikuje.',
  'MYFXBOOK ACCOUNT ID OR PUBLIC URL': 'MYFXBOOK ID NALOGA ILI JAVNI URL',
  'e.g. 1234567 or https://www.myfxbook.com/members/you/name/1234567':
    'npr. 1234567 ili https://www.myfxbook.com/members/you/name/1234567',
  'Imported': 'Uvezeno',
  'trades': 'trejdova',
  'closed': 'zatvorenih',
  'w': ' ned',
  'Connected — does not yet pass the verification gates (≥30 trades, ≥6 weeks, DD≤40%, PF≥1.2).':
    'Povezano — još ne prolazi kriterijume verifikacije (≥30 trejdova, ≥6 nedelja, DD≤40%, PF≥1.2).',
  'Importing…': 'Uvoz…',
  'Import Myfxbook account': 'Uvezi Myfxbook nalog',
  'Connect MT4 / MT5 (read-only)': 'Poveži MT4 / MT5 (samo za čitanje)',
  'Connect any MetaTrader broker with your': 'Poveži bilo kog MetaTrader brokera koristeći svoju',
  'investor (read-only) password': 'investitorsku lozinku (samo za čitanje)',
  'We read your verified history and apply the same gates →':
    'Čitamo tvoju verifikovanu istoriju i primenjujemo iste kriterijume →',
  'Account links in ~30–90s.': 'Nalog se povezuje za ~30–90 s.',
  'account': 'nalog',
  'Connection error': 'Greška u povezivanju',
  'Connecting…': 'Povezivanje…',
  'CONNECTED (below gates)': 'POVEZAN (ispod kriterijuma)',
  'Use the': 'Koristi',
  "— never your master password. It's stored encrypted in our vault, never shown in the browser, and used read-only.":
    '— nikada glavnu (master) lozinku. Čuva se šifrovana u našem trezoru, nikad se ne prikazuje u pregledaču i koristi se samo za čitanje.',
  'PLATFORM': 'PLATFORMA',
  'BROKER SERVER': 'SERVER BROKERA',
  'e.g. ICMarketsSC-Demo': 'npr. ICMarketsSC-Demo',
  'e.g. 5012345': 'npr. 5012345',
  'INVESTOR PASSWORD': 'INVESTITORSKA LOZINKA',
  'read-only password': 'lozinka samo za čitanje',
  'Connect MT4 / MT5': 'Poveži MT4 / MT5',
  'Verify on-chain (Hyperliquid)': 'Verifikuj on-chain (Hyperliquid)',
  'Trustless & instant: sign a message to prove you own your wallet (':
    'Bez poverenja i trenutno: potpiši poruku da dokažeš vlasništvo nad novčanikom (',
  'no keys, no funds moved': 'bez ključeva, sredstva se ne pomeraju',
  '), and we read your public Hyperliquid history on-chain and apply the same gates →':
    '), a mi čitamo tvoju javnu Hyperliquid istoriju on-chain i primenjujemo iste kriterijume →',
  'No EVM wallet found. Install MetaMask (or another browser wallet) and try again.':
    'EVM novčanik nije pronađen. Instaliraj MetaMask (ili drugi novčanik u pregledaču) i pokušaj ponovo.',
  'No wallet account selected.': 'Nijedan nalog novčanika nije izabran.',
  'Signature request rejected.': 'Zahtev za potpis je odbijen.',
  'Wallet error — please try again': 'Greška novčanika — pokušaj ponovo',
  'Verification failed': 'Verifikacija nije uspela',
  'Connection failed': 'Povezivanje nije uspelo',
  'Import failed': 'Uvoz nije uspeo',
  'Network error — please try again': 'Greška mreže — pokušaj ponovo',
  'Wallet verified — history does not yet pass the gates (≥30 trades, ≥6 weeks, DD≤40%, PF≥1.2).':
    'Novčanik je verifikovan — istorija još ne prolazi kriterijume (≥30 trejdova, ≥6 nedelja, DD≤40%, PF≥1.2).',
  'Check your wallet to sign…': 'Proveri novčanik i potpiši…',
  'Connect & sign': 'Poveži i potpiši',
  "or, if you can't connect an account": 'ili, ako ne možeš da povežeš nalog',
  'Your statement submissions': 'Tvoji poslati izveštaji',
  'MT4 statement': 'MT4 izveštaj',
  'MT5 statement': 'MT5 izveštaj',
  'Broker PDF': 'PDF brokera',
  'Prop-firm certificate': 'Sertifikat prop firme',
  'Upload a statement (human-reviewed)': 'Pošalji izveštaj (ručna provera)',
  'Earns a': 'Donosi',
  'badge after review. Upload the': 'bedž nakon provere. Pošalji',
  'full statement': 'kompletan izveštaj',
  '(PDF or MT4/MT5 HTML) showing your account number & broker server —':
    '(PDF ili MT4/MT5 HTML) na kome se vide broj naloga i server brokera —',
  'not a screenshot': 'ne snimak ekrana',
  '. Live broker connect above is faster and unforgeable; this is the fallback.':
    '. Direktno povezivanje brokera iznad je brže i ne može se falsifikovati; ovo je rezervna opcija.',
  'DOCUMENT TYPE': 'TIP DOKUMENTA',
  'e.g. IC Markets': 'npr. IC Markets',
  'ACCOUNT NUMBER / LOGIN': 'BROJ NALOGA / LOGIN',
  'STATEMENT FILE (PDF / HTML)': 'FAJL IZVEŠTAJA (PDF / HTML)',
  'Upload the full statement as PDF or MT4/MT5 HTML — not a screenshot.':
    'Pošalji kompletan izveštaj kao PDF ili MT4/MT5 HTML — ne snimak ekrana.',
  'File too large (max 10MB).': 'Fajl je prevelik (maks. 10MB).',
  'Upload failed': 'Otpremanje nije uspelo',
  'Could not record submission': 'Nije moguće zabeležiti prijavu',
  "Submitted for review — you'll get the badge once an admin approves it.":
    'Poslato na proveru — dobićeš bedž čim administrator odobri.',
  'Uploading…': 'Otpremanje…',
  'Submit for review': 'Pošalji na proveru',
};
